<section class="p-4 container-fluid">
  <div class="row g-4">
    <div class="col-12" [class.col-lg-4]="activeTab === 'tenant'">
      <p-card>
        <p-tabs [(value)]="activeTab">
          <p-tablist>
            <p-tab value="tenant">Propietarios e inquilinos</p-tab>
            <p-tab value="admin">Administradores y gestores</p-tab>
          </p-tablist>

          <p-tabpanels>
            <p-tabpanel value="tenant">
              <h3 class="register-tab-title">Registro para propietarios e inquilinos</h3>
              <p class="text-secondary register-tab-intro">
                Para el registro necesitarás los datos de tu liquidación. Puedes ver los ejemplos en la parte
                derecha de la pantalla.
              </p>

              <p-message styleClass="mb-3 w-100" severity="info">
                El código y el importe aparecen en tu liquidación. Si tienes dudas, consulta los ejemplos del
                carrusel o contacta con atención al cliente.
              </p-message>

              <form [formGroup]="tenantForm" class="form-container" (ngSubmit)="submitTenant()">
                <div class="field-block my-3">
                  <p-floatlabel class="d-block" variant="in">
                    <p-iconfield>
                      <p-inputicon class="pi pi-envelope" />
                      <input pInputText type="email" id="tenantEmail" class="w-100" formControlName="email" />
                    </p-iconfield>
                    <label for="tenantEmail">Email</label>
                  </p-floatlabel>
                  @if (shouldShowError(tenantForm.get('email'))) {
                    <small class="field-error">{{ getControlError(tenantForm.get('email'), 'email') }}</small>
                  }
                </div>

                <div class="field-block my-3">
                  <p-floatlabel class="d-block" variant="in">
                    <p-iconfield>
                      <p-inputicon class="pi pi-phone" />
                      <input
                        pInputText
                        type="tel"
                        id="tenantPhone"
                        class="w-100"
                        formControlName="phone"
                        autocomplete="tel"
                        inputmode="numeric"
                        maxlength="15"
                      />
                    </p-iconfield>
                    <label for="tenantPhone">Teléfono móvil</label>
                  </p-floatlabel>
                  <small class="field-hint">Opcional, pero recomendado para avisos y gestiones.</small>
                  @if (shouldShowError(tenantForm.get('phone'))) {
                    <small class="field-error">{{ getControlError(tenantForm.get('phone'), 'phone') }}</small>
                  }
                </div>

                <div class="field-block my-3">
                  <p-floatlabel class="d-block" variant="in">
                    <p-iconfield>
                      <p-inputicon class="pi pi-circle-fill fillCode" />
                      <input
                        pInputText
                        type="text"
                        id="liquidationCode"
                        class="w-100"
                        formControlName="liquidationCode"
                      />
                    </p-iconfield>
                    <label for="liquidationCode">Código Liquidación</label>
                  </p-floatlabel>
                  <small class="field-hint">Lo encontrarás en el recuadro morado de tu liquidación.</small>
                  @if (shouldShowError(tenantForm.get('liquidationCode'))) {
                    <small class="field-error">{{ getControlError(tenantForm.get('liquidationCode'), 'liquidationCode') }}</small>
                  }
                </div>

                <div class="field-block my-3">
                  <p-floatlabel class="d-block" variant="in">
                    <p-iconfield>
                      <p-inputicon class="pi pi-circle-fill fillAmount" />
                      <input
                        pInputText
                        type="number"
                        step="0.01"
                        min="0"
                        id="liquidationAmount"
                        class="w-100"
                        formControlName="liquidationAmount"
                      />
                    </p-iconfield>
                    <label for="liquidationAmount">Importe Liquidación</label>
                  </p-floatlabel>
                  <small class="field-hint">Introduce el importe tal como aparece en tu liquidación. Ej: 42,50</small>
                  @if (shouldShowError(tenantForm.get('liquidationAmount'))) {
                    <small class="field-error">{{ getControlError(tenantForm.get('liquidationAmount'), 'liquidationAmount') }}</small>
                  }
                </div>

                <div class="d-flex align-items-start gap-2 my-3">
                  <p-checkbox [formControl]="tenantConditions" [binary]="true" inputId="tenantPrivacy" />
                  <label for="tenantPrivacy" class="small">
                    Acepto el
                    <a [href]="legalNoticeUrl" target="_blank" rel="noopener noreferrer">aviso legal</a>
                    y la
                    <a [href]="privacyPolicyUrl" target="_blank" rel="noopener noreferrer">política de privacidad</a>.
                  </label>
                </div>
                @if (shouldShowError(tenantConditions)) {
                  <small class="field-error d-block mb-2">{{ getControlError(tenantConditions, 'conditions') }}</small>
                }

                @if (tenantError) {
                  <p-message styleClass="mb-3 w-100" severity="error">{{ tenantError }}</p-message>
                }
                @if (tenantSuccess) {
                  <p-message styleClass="mb-3 w-100" severity="success">
                    Registro solicitado correctamente. Revisa tu correo para completar el proceso.
                  </p-message>
                }

                <p-button
                  type="submit"
                  label="Registrarme"
                  class="w-100"
                  [style]="{ width: '100%' }"
                  [disabled]="tenantForm.invalid || tenantConditions.invalid || tenantLoading"
                  [loading]="tenantLoading"
                />
              </form>
            </p-tabpanel>

            <p-tabpanel value="admin">
              <h3 class="register-tab-title">Solicitud de acceso</h3>
              <p-message styleClass="mb-3 w-100" severity="info">
                El registro directo solo está disponible para propietarios e inquilinos. Si eres administrador de fincas,
                gestor o ayuntamiento, solicita tu acceso y atención al cliente se pondrá en contacto contigo.
              </p-message>

              <p class="small text-secondary mb-3">
                También puedes contactar en
                <a [href]="'mailto:' + supportEmail">{{ supportEmail }}</a>
                o {{ supportPhone }}.
              </p>

              <form [formGroup]="adminForm" class="form-container" (ngSubmit)="submitAdminRequest()">
                <div class="field-block my-3">
                  <p-floatlabel class="d-block" variant="in">
                    <p-iconfield>
                      <p-inputicon class="pi pi-envelope" />
                      <input pInputText type="email" id="adminEmail" class="w-100" formControlName="email" />
                    </p-iconfield>
                    <label for="adminEmail">Email</label>
                  </p-floatlabel>
                  @if (shouldShowError(adminForm.get('email'))) {
                    <small class="field-error">{{ getControlError(adminForm.get('email'), 'email') }}</small>
                  }
                </div>

                <div class="field-block my-3">
                  <p-floatlabel class="d-block" variant="in">
                    <p-iconfield>
                      <p-inputicon class="pi pi-phone" />
                      <input pInputText type="tel" id="adminPhone" class="w-100" formControlName="phone" />
                    </p-iconfield>
                    <label for="adminPhone">Teléfono</label>
                  </p-floatlabel>
                  @if (shouldShowError(adminForm.get('phone'))) {
                    <small class="field-error">{{ getControlError(adminForm.get('phone'), 'phone') }}</small>
                  }
                </div>

                <div class="d-flex align-items-start gap-2 my-3">
                  <p-checkbox [formControl]="adminConditions" [binary]="true" inputId="adminPrivacy" />
                  <label for="adminPrivacy" class="small">
                    Acepto el
                    <a [href]="legalNoticeUrl" target="_blank" rel="noopener noreferrer">aviso legal</a>
                    y la
                    <a [href]="privacyPolicyUrl" target="_blank" rel="noopener noreferrer">política de privacidad</a>.
                  </label>
                </div>
                @if (shouldShowError(adminConditions)) {
                  <small class="field-error d-block mb-2">{{ getControlError(adminConditions, 'conditions') }}</small>
                }

                @if (adminError) {
                  <p-message styleClass="mb-3 w-100" severity="error">{{ adminError }}</p-message>
                }
                @if (adminSuccess) {
                  <p-message styleClass="mb-3 w-100" severity="success">
                    Hemos recibido tu solicitud. Atención al cliente se pondrá en contacto contigo.
                  </p-message>
                }

                <p-button
                  type="submit"
                  label="Solicitar registro"
                  severity="secondary"
                  class="w-100"
                  [style]="{ width: '100%' }"
                  [disabled]="adminForm.invalid || adminConditions.invalid || adminLoading"
                  [loading]="adminLoading"
                />
              </form>
            </p-tabpanel>
          </p-tabpanels>
        </p-tabs>

        <div class="d-flex justify-content-center mt-3">
          <p-button severity="secondary" link routerLink="/login">¿Ya estás registrado? Inicia sesión</p-button>
        </div>
      </p-card>
    </div>

    @if (activeTab === 'tenant') {
      <div class="col-12 col-lg-7 offset-lg-1">
        <div class="carousel-wrapper">
          <p-carousel
            [value]="images"
            [autoplayInterval]="4000"
            [numScroll]="1"
            [numVisible]="1"
            circular
            [showIndicators]="false"
            class="carousel-container"
          >
            <ng-template pTemplate="item" let-image>
              <div class="carousel-item-wrapper">
                <div class="carousel-image">
                  <p-image [src]="image.src" [preview]="true" appendTo="body" [alt]="image.title" />
                </div>
                <p class="carousel-title">{{ image.title }}</p>
              </div>
            </ng-template>
          </p-carousel>
        </div>
      </div>
    }
  </div>
</section>

<p-dialog
  header="Teléfono no introducido"
  [(visible)]="showTenantPhoneReminderDialog"
  [modal]="true"
  [closable]="true"
  [draggable]="false"
  [style]="{ width: 'min(28rem, 92vw)' }"
>
  <p class="m-0 mb-4">
    No has introducido el teléfono. Para una mejor experiencia y poder contactarte con rapidez sobre tus
    gestiones, te recomendamos añadir tu número móvil antes de continuar.
  </p>
  <div class="d-flex flex-wrap gap-2 justify-content-end">
    <p-button
      type="button"
      label="Cancelar"
      severity="secondary"
      [outlined]="true"
      (onClick)="cancelTenantPhoneReminder()"
    />
    <p-button type="button" label="Continuar sin teléfono" (onClick)="continueTenantWithoutPhone()" />
  </div>
</p-dialog>
